import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UtilitiesService} from '../core/_services/utilities.service';
import {UserService} from '../core/_services/user.service';

@Component({
  selector: 'app-site-maintenance',
  templateUrl: './site-maintenance.component.html',
  styleUrls: ['./site-maintenance.component.scss']
})
export class SiteMaintenanceComponent implements OnInit {

    busy: boolean = false;
    timeLeft: string = "1 hour";

    constructor(private activatedRoute: ActivatedRoute,
                private userService: UserService,
                private router: Router) { }

    ngOnInit() {
        this.activatedRoute.paramMap.subscribe(() => {
            const state = window.history.state;
            if (state && state.endDate) {
                const endDate: Date = UtilitiesService.dateFromString(state.endDate);
                this.timeLeft = SiteMaintenanceComponent.calculateTimeLeft(endDate);
            }
        });
    }

    checkMaintenance() {
        this.busy = true;

        this.userService.validateLocation({}, this.constructor.name).subscribe((resp: any) => {
            if (resp && resp.responseCode != 2000) {
                this.router.navigateByUrl("/appointments");
            } else if (resp && resp.maintenanceEnd) {
                const endDate = UtilitiesService.dateFromString(resp.maintenanceEnd);
                this.timeLeft = SiteMaintenanceComponent.calculateTimeLeft(endDate);
            }
            this.busy = false;
        });

    } // checkMaintenance()

    private static calculateTimeLeft(endDate: Date) {
        const timeDiff = endDate.getTime() - Date.now();
        if (timeDiff < (22 * 60 * 1000)) {
            return "about 15 minutes";
        } else if (timeDiff < (37 * 60 * 1000)) {
            return "about 30 minutes";
        } else if (timeDiff < (52 * 60 * 1000)) {
            return "roughly 45 minutes";
        } else if (timeDiff < (75 * 60 * 1000)) {
            return "an hour or so";
        } else {
            return "a few hours";
        }
    }

}
